import topic from "common/managers/topic";
import locale from "common/managers/locale";
import BasicGrid from "app/widgets/DFGrid/BasicGrid";
export default {
    /**
     * The global notification widget.
     */
    notify: undefined,

    // reference to error window
    errorWindow: undefined,
    // the grid widget within the popup window
    errorWindowGrid: undefined,

    initNotification: function() {
        topic.subscribe("success/message", $.proxy(this.showSuccessNotification, this));
        topic.subscribe("success/partial/message", $.proxy(this.showPartialSuccessNotification, this));
        topic.subscribe("app/notify/error", $.proxy(this.showErrorNotification, this));
        topic.subscribe("app/notify/errorRequest", $.proxy(this.showErrorObject, this));
        topic.subscribe("app/notify/custom", $.proxy(this.showNotification, this));
        topic.subscribe("app/notify/tip", $.proxy(this.showTipNotification, this));
        topic.subscribe("app/notify/clear", $.proxy(this.clearNotifications, this));
    },

    /**
     * Configures and opens the popup window, displaying errors for specific items.
     */
    viewErrors: function(obj) {
        var items = obj.items,
            columns = obj.columns,
            errorMessages = obj.failures;
        // initialize the datasource with combination of returned errors and passed data items.
        // this is the datasource feeding the grid widget in the popup window.
        var errors = new kendo.data.DataSource({
            pageSize: 50,
            serverPaging: false
        });

        if (items) {
            var me = this;
            for (var i = 0; i < items.length; i++) {
                $.each(errorMessages, function(j, error) {
                    if (error.targetId == items[i].id) {
                        errors.add($.extend(error, items[i]));
                    }
                });
            }
        }
        // initialize columns
        var gridCols = [];
        if (columns) {
            $.each(columns, function(i, col) {
                if (col.command == undefined) {
                    if (col.field !== "spacer") {
                        gridCols.push({
                            field: col.field,
                            title: col.title,
                            format: col.format,
                            width: '150px'
                        });
                    } else {
                        gridCols.push({
                            field: col.field,
                            title: col.title,
                            format: col.format,
                            width: '50px'
                        });
                    }
                }
            });
        }
        gridCols.push({
            field: 'failureCause',
            localizedTitle: 'error.title',
            width: '100px'
        });
        // initialize the grid, with above calculated columns and data
        var el = $('<div id="global_error_grid" class="miniGrid df-small-grid"></div>');
        this.errorWindow().element.find(".dialogContent").append(el);
        this.errorWindowGrid = new BasicGrid(el, {
            columns: gridCols,
            defaultPaging: true,
            dataSource: errors,
            resizable: true
        });
        // open window showing errors
        this.errorWindow().open();
    },

    handleErrorWindowClosed: function() {
        this.errorWindowGrid.destroy();
        this.errorWindow().element.find(".dialogContent").empty();
    },

    /**
     * Handle partial failures / successes, by showing a specialized warning notification. This method parses
     * the partial failure object generically, displaying appropriate details.
     *
     * @param data the partial failure response from the server
     */
    showPartialSuccessNotification: function(data, items, columns) {
        var failureDetails;
        if (data.successFailureReportDto) {
            failureDetails = data.successFailureReportDto.failureDetails;
        }
        this.showCustomNotification(data, "warning", failureDetails, items, columns);
    },

    /**
     * Handle full failures from multi-select actions that support partial failures. This method parses
     * the partial failure object generically, displaying appropriate details.
     * @param data
     */
    showErrorNotification: function(data, items, columns) {
        var failureDetails;
        if (data.successFailureReportDto && data.successFailureReportDto.failureDetails) {
            failureDetails = data.successFailureReportDto.failureDetails;
        }
        this.showCustomNotification(data, "error", failureDetails, items, columns);
    },

    /**
     * Show a notification.
     * @param content the content to send to the notification widget, containing data to display
     * @param type "success", "info", "error", or "warning"
     */
    showCustomNotification: function(content, type, failures, items, columns) {
        var obj = {
            message: content.message,
            hasErrors: columns !== undefined
        };
        if (content.uid) {
            obj.uid = content.uid;
        }
        this.notify().show(obj, type, {
            items: items,
            columns: columns,
            failures: failures
        });
    },

    /**
     * Show a success notification based on locale key, or user-entered text. customMessage should ONLY be used
     * to display user-entered text in a custom success notification. If using DF-localized text, always
     * send the locale key in successKey.  successKey will be used unless it is not defined.
     *
     * @param data Object with format of {successKey: locale key} or {customMessage: localized or custom text}
     */
    showSuccessNotification: function(data) {
        if (data.successKey) {
            this.showNotification(data.successKey, "success");
        } else {
            this.notify().showText(data.customMessage, "success");
        }
    },

    _getLocaleMessage: function(messageKey, data) {
        if (data !== undefined && data instanceof Array) {
            var args = [messageKey].concat(data);
            return locale.get.apply(locale, args);
        } else if (data !== undefined) {
            return locale.get(messageKey, data)
        } else {
            return locale.get(messageKey)
        }
    },

    /**
     * Show a notification in the main notification area. Handles all types.
     * @param messageKey
     * @param type
     * @param data Extra data to localize
     */
    showNotification: function(messageKey, type, data) {
        var msg = this._getLocaleMessage(messageKey, data);

        // Format for error and warning templates
        if (type == "error" || type == "warning" || type == "info") {
            msg = {
                message: msg,
                hasErrors: false
            };
        }
        this.notify().showText(msg, type || "success");
    },

    showErrorObject: function(error, type) {
        this.notify().showText({
            message: error.message,
            hasErrors: false
        }, type);
    },

    showTipNotification: function(messageKey, data) {
        var msg = this._getLocaleMessage(messageKey, data);
        this.notify().show({
            message: msg,
            hotkey: true
        }, "info");
    },

    clearNotifications: function() {
        this.notify().hide();
    }

};
